module.exports = __webpack_public_path__ + "static/img/home.544ef52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/home.png
// module id = mQdu
// module chunks = 1